"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = exports.StyledButtonText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.button `
  display: block;
  padding: ${(props) => (props.withText ? '8px 16px' : '8px')};
  background: transparent;
  border: none;
  border-radius: ${(props) => ({
    default: '8px',
    brick: '0',
    round: '24px',
    brickRound: '0 24px 24px 0',
    roundBrick: '24px 0 0 24px',
    brickDefault: '0 8px 8px 0',
    defaultBrick: '8px 0 0 8px',
}[props.form])};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  transition: 0.3s;
  outline: none;
  cursor: pointer;

  ${(props) => props.withIcon &&
    `
      display: flex;
      align-items: center;
    `}

  &:disabled {
    pointer-events: none;
  }
  &:active {
    opacity: 0.9;
  }
  &:focus {
    outline: none;
  }

  &[data-full-screen='true'] {
    width: 100%;
  }

  &[data-size='big'] {
    padding: 12px 32px;
  }

  &[data-variation='primary'] {
    background: var(--primary-color, #367bf5);
    color: #fff;

    &:hover {
      opacity: 0.8;
    }
    &:disabled {
      background: #ebebeb;
      color: #909090;
    }
  }

  &[data-variation='secondary'] {
    padding: 7px 15px;
    border: 2px solid var(--primary-color, #367bf5);
    color: var(--primary-color, #367bf5);

    ${(props) => props.withIcon &&
    `
        display: flex;
        align-items: center;
     `}

    &[data-size='big'] {
      padding: 11px 31px;
    }

    &:hover {
      background: var(--primary-color, #367bf5);
      color: #fff;
    }
    &:disabled {
      border: 1px solid #ebebeb;
      color: #909090;
    }
  }

  &[data-variation='ternary'] {
    padding: 0;
    color: var(--primary-color, #367bf5);

    &:hover {
      opacity: 0.8;
    }
    &:disabled {
      color: #909090;
    }
  }

  &[data-variation='dashed'] {
    padding: 0;
    font-weight: 400;
    color: var(--primary-color, #367bf5);
    border-radius: 0;
    border-bottom: 1px dashed var(--primary-color, #367bf5);

    &:active,
    &.active {
      color: #212121;
      border-bottom: 1px dashed #ebebeb;
    }

    &:hover {
      color: #212121;
      border-bottom: 1px dashed #212121;
      opacity: 0.8;
    }

    &:disabled {
      color: #909090;
    }
  }
`;
exports.StyledButtonText = styled_components_1.default.span `
  margin: ${(props) => ({ left: '0 0 0 8px', right: '0 8px 0 0' }[props.iconPosition])};
`;
exports.StyledIconButton = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=button.styled.js.map